import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import little_explorer from "../../assets/images/little_explore.jpeg";
export default function AdmissionModal({ isOpen, onClose }) {
  const rootRef = useRef(null);

  // Lock scroll + ESC close
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    const prev = document.body.style.overflow;
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev || "";
    };
  }, [isOpen, onClose]);

  if (!isOpen || typeof document === "undefined") return null;

  const content = (
    <>
      <style>{`
        .adm-backdrop {
          position: fixed; inset: 0; z-index: 9999;
          display: grid; place-items: center;
          width: 100svw; height: 100svh;
          background: rgba(0,0,0,0.55);
          overscroll-behavior: contain;
        }

        .adm-card {
          width: min(500px, calc(100svw - 32px));
          background: #fff;
          border-radius: 18px;
          box-shadow: 0 8px 28px rgba(0,0,0,0.25);
          padding: clamp(20px, 5vw, 32px);
          text-align: center;
          animation: fadeIn 0.25s ease;
        }

        .adm-title {
          font-size: clamp(22px, 5vw, 28px);
          font-weight: 800;
          color: #1e293b;
          margin-bottom: 12px;
        }

        .adm-sub {
          font-size: clamp(15px, 3.5vw, 18px);
          color: #475569;
          line-height: 1.5;
          margin-bottom: 22px;
        }

        .adm-actions {
          display: flex; justify-content: center;
        }

        .adm-btn {
          background: #293c89;
          color: #fff;
          font-weight: 600;
          padding: 12px 24px;
          border-radius: 10px;
          text-decoration: none;
          box-shadow: 0 4px 10px rgba(41,60,137,0.18);
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @media (prefers-color-scheme: dark) {
          .adm-card { background: #0b1220; }
          .adm-title { color: #e5e7eb; }
          .adm-sub { color: #9ca3af; }
        }
      `}</style>

      <div
        className="adm-backdrop"
        onClick={onClose}
        role="dialog"
        aria-modal="true"
      >
        <div className="adm-card" onClick={(e) => e.stopPropagation()}>
          <img src={little_explorer} alt="Admission" className="adm-img" />
        </div>
      </div>
    </>
  );

  return createPortal(content, document.body);
}
